<mat-card appearance="outlined" class="syn-card">
    <mat-card-header>
        <mat-card-title>
            Comparaison des modifications
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="timeline">
            <div class="timeline__content" [ngClass]="{ animate: animate, goLeft: leftAnimation, goRight: rightAnimation }">
                <ng-container *ngTemplateOutlet="updatedBySkeleton"></ng-container>

                <div *ngIf="previousLog; else noLog" class="updated-by" (click)="goPreviousLog()">
                    <syn-user-avatar
                        [user]="previousLog.$who"
                        [showLegend]="true"
                        [clickable]="false"
                        [caption]="previousLog.$who.id"
                    ></syn-user-avatar>

                    <div class="updated-by__indicator">
                        <p>{{ previousLog.when | date:'d MMMM y à HH:mm' }}</p>
                    </div>
                </div>

                <div class="updated-by">
                    <syn-user-avatar
                        [user]="log.$who"
                        [showLegend]="true"
                        [clickable]="false"
                        [caption]="log.$who.id"
                    ></syn-user-avatar>

                    <div class="updated-by__indicator">
                        <p>{{ log.when | date:'d MMMM y à HH:mm' }}</p>
                    </div>
                </div>

                <div *ngIf="nextLog; else noLog" class="updated-by" (click)="goNextLog()">
                    <syn-user-avatar
                        [user]="nextLog.$who"
                        [showLegend]="true"
                        [clickable]="false"
                        [caption]="nextLog.$who.id"
                    ></syn-user-avatar>

                    <div class="updated-by__indicator">
                        <p>{{ nextLog.when | date:'d MMMM y à HH:mm' }}</p>
                    </div>
                </div>

                <ng-container *ngTemplateOutlet="updatedBySkeleton"></ng-container>
            </div>
        </div>

        <syn-page-loader [loading]="loading || animate"></syn-page-loader>

        <table *ngIf="!loading" fxFlexFill class="mat-table">
            <tr *ngIf="resource.length" class="mat-row">
                <td class="mat-cell">Identité de la ressource modifiée</td>
                <td class="mat-cell">
                    <ul>
                        <li *ngFor="let res of resource">
                            {{ res.key }}: {{ res.value }}
                        </li>
                    </ul>
                </td>

            </tr>
            <tr *ngFor="let diffLog of diffLogs" class="mat-row">
                <td class="mat-cell mat-cell--path">
                    <div class="path-wrapper">
                        <p>{{ diffLog.path }}</p>

                        <mat-icon *ngIf="diffLog.hasTooltip"
                                  matTooltip="Certains champs ne peuvent pas être affichés en mode simplifié et sont donc affichés au format JSON."
                                  color="primary"
                                  svgIcon="information-outline"
                        ></mat-icon>
                    </div>
                </td>

                <td class="mat-cell">
                    <mat-list>
                        <mat-list-item *ngFor="let previous of diffLog.previous">
                            <ng-container *ngTemplateOutlet="printValue;context:{value: previous, type: 'removed'}"></ng-container>
                        </mat-list-item>

                        <mat-list-item *ngFor="let current of diffLog.current">
                            <ng-container *ngTemplateOutlet="printValue;context:{value: current, type: 'added'}"></ng-container>
                        </mat-list-item>

                        <ng-container *ngIf="diffLog.removed.length > 0">
                            <h3 *ngIf="diffLog.isObject" matSubheader>Supprimé</h3>
                            <mat-list-item *ngFor="let removed of diffLog.removed">
                                <ng-container *ngTemplateOutlet="printValue;context:{value: removed, type: 'removed'}"></ng-container>
                            </mat-list-item>
                        </ng-container>

                        <ng-container *ngIf="diffLog.added.length > 0">
                            <h3 *ngIf="diffLog.isObject" matSubheader>Ajouté</h3>
                            <mat-list-item *ngFor="let added of diffLog.added">
                                <ng-container *ngTemplateOutlet="printValue;context:{value: added, type: 'added'}"></ng-container>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </td>
            </tr>
        </table>
    </mat-card-content>
</mat-card>

<ng-template #printValue let-value="value" let-type="type">
    <ng-container *ngIf="value.raw && value.parsed">
        <div *ngIf="isObject(value.parsed)" class="code-wrapper">
            <pre [className]="type">
                <code [highlight]="value.raw"></code>
            </pre>
        </div>

        <ng-container *ngIf="!isObject(value.parsed)">
            <p [className]="type">
                {{ value.parsed }}
            </p>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #noLog>
    <div class="no-log"></div>
</ng-template>

<ng-template #updatedBySkeleton>
    <div class="updated-by skeleton">
        <div class="user-avatar">
            <div class="user-avatar__picture"></div>
            <div>
                <div class="user-avatar__name"></div>
                <div class="user-avatar__id"></div>
            </div>
        </div>

        <div class="updated-by__indicator">
            <div class="date"></div>
        </div>
    </div>
</ng-template>
